import {
  FormCard,
  FormItem,
  Input,
  FormRadio,
  FormRadioGroup,
} from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { Text } from '@lmc/ui-kit/src/general'
import { useSelector } from 'react-redux'
import { ContingencyPlanDTO, Home } from '@lmc/ts-common'
import { getNominative } from 'common/utils'
import { useState } from 'react'
import { Form as AntdForm, RadioChangeEvent } from 'antd'
import { SupDatePicker } from 'screens/Residents/screens/ResidentProfileScreen/styledComponents'
import { dateFormat } from 'screens/Residents/screens/ResidentProfileScreen/utils/utils'
import dayjs from 'dayjs'

type OtherDetailsFormCardProps = { plan: ContingencyPlanDTO | undefined }

const OtherDetailsFormCard = ({ plan }: OtherDetailsFormCardProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const preferredPeopleNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative
  )
  const residentNominative = getNominative(
    preferredPeopleNominative,
    'Resident'
  )
  const [
    shouldShowLegitimateRepresentativeInput,
    setShouldShowLegitimateRepresentativeInput,
  ] = useState(Boolean(plan?.agreedWithOtherPerson))

  const onRadioChange = (e: RadioChangeEvent) => {
    setShouldShowLegitimateRepresentativeInput(e.target.value === false)
  }

  return (
    <FormCard title={t(supConstants.OTHER_DETAILS)}>
      <FormItem
        label={<Text>{t(supConstants.AGREED_WITH_PERSON)} </Text>}
        name="agreedWithServiceUser"
        rules={[
          {
            required: true,
            message: `${t(supConstants.PLEASE_ENTER)} ${t(
              supConstants.AGREED_WITH_PERSON
            )}`,
          },
        ]}
      >
        <FormRadioGroup
          onChange={onRadioChange}
          value={Boolean(plan?.agreedWithOtherPerson)}
        >
          <FormRadio value text={residentNominative} />
          <FormRadio
            value={false}
            text={t(supConstants.LEGITIMATE_REPRESENTATIVE)}
          />
        </FormRadioGroup>
      </FormItem>
      {shouldShowLegitimateRepresentativeInput && (
        <FormItem
          name="agreedWithOtherPerson"
          label=" "
          colon={false}
          required={false}
          dependencies={['agreedWithServiceUser']}
          rules={[
            {
              required: true,
              message: `${t(supConstants.PLEASE_ENTER)} ${t(
                supConstants.LEGITIMATE_REPRESENTATIVE
              )}`,
            },
          ]}
        >
          <Input max={50} />
        </FormItem>
      )}
      <AntdForm.Item noStyle dependencies={['nextReviewDate']}>
        {({ setFieldValue }) => (
          <FormItem
            required
            label={<Text> {t(supConstants.NEXT_REVIEW)} </Text>}
            name="checkboxNextReviewDate"
          >
            <FormRadioGroup
              onChange={(e) => {
                setFieldValue(
                  'nextReviewDate',
                  dayjs().add(e.target.value, 'months').startOf('day')
                )
              }}
            >
              <FormRadio value={1} text={t(supConstants.ONE_MONTH)} />
              <FormRadio value={3} text={t(supConstants.THREE_MONTHS)} />
              <FormRadio value={6} text={t(supConstants.SIX_MONTHS)} />
              <FormRadio value={12} text={t(supConstants.TWELVE_MONTHS)} />
            </FormRadioGroup>
          </FormItem>
        )}
      </AntdForm.Item>
      <FormItem
        colon={false}
        label=" "
        name="nextReviewDate"
        required={false}
        rules={[
          {
            required: true,
            message: `${t(supConstants.PLEASE_ENTER)} ${t(
              supConstants.NEXT_REVIEW
            )}`,
          },
        ]}
      >
        <SupDatePicker placeholder="" format={dateFormat} />
      </FormItem>
    </FormCard>
  )
}

export default OtherDetailsFormCard
